import commonApi from '@/api/_common.js'

export default {
    getList(param, scb, fcb, va) {
        const pageNo = param?.page_no ?? 1
        const pageSize = param?.page_size ?? 25
        const params = new URLSearchParams({
            page_no: pageNo,
            page_size: pageSize,
            ...(param?.search_type && { search_type: param.search_type }),
            ...(param?.search_text && { search_text: param.search_text }),
            ...(param?.block_yn && { block_yn: param.block_yn })
        })
        const reqURL = `/svc/block_mdn_list?${params}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.block_mdn_list, data.total_count)
            }
        }, (err) => {
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    }
}
